angular.module 'app'
.controller 'ImagesController', ($timeout, $scope, $http, $state, $stateParams, $ionicPopup, config, activeUser, ionicMaterialInk) ->
  $scope.ui =
    load_show: false
    title: ''
    baseUrl: config.api.baseUrl
    homepage: activeUser.homepage
    userInfo: activeUser.user
    column: {}
    images: []
    count: 0

  do findColumn = ->
    $http.get "#{config.api.baseUrl}/cumpus/programa/#{$stateParams.column_id}", {}
    .then (res) ->
      $scope.ui.column = res.data
      $scope.ui.title = $scope.ui.column.programa_name
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統出錯！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )

  findImages = ->
    $http.get "#{config.api.baseUrl}/cumpus/programa/list",
      params:
        is_show: true
        programa_id: $stateParams.column_id
        group_id: activeUser.group_id
        sort: '-created_at'
        offset: $scope.ui.images.length
        limit: 8
    .then (res) ->
      images = res.data.data
      _.each images, (val) ->
        val.created_at = moment(val.created_at).format 'YYYY-MM-DD'

      $scope.ui.images = $scope.ui.images.concat images
      $scope.ui.count = res.data.count

      if $scope.ui.images.length is $scope.ui.count
        $scope.ui.load_show = true
      $scope.$broadcast('scroll.infiniteScrollComplete')
      $timeout (->
        ionicMaterialInk.displayEffect()
      ), 1000
    .catch (error) ->
      $ionicPopup.alert(
        title: "錯誤"
        template: "系統出錯！"
        buttons: [
          {text: '<b>關閉</b>', type: 'button-positive'}
        ]
      )

  $scope.findImages = findImages
  
  $scope.toArticle = (article) ->
    $state.go("app.article", {column_id: $stateParams.column_id, article_id: article._id})